module.exports = __webpack_public_path__ + "img/icon-step-5.04444543.svg";